import { nextTick } from 'vue';
import config from '@/services/config';
import globals from '@/services/globals';
import CustomMessageBox from '@/services/CustomMessageBox';

function createOfferActionResponseHandler(oM, b) {
    
    let offerManager = oM;
    let bus = b;
    let componentResponseHandlers = {};
    let disposed = false;

    function handler (options) {
        let { actionType, actionId, callback: optionalThenFunc, data: optionalData, namedComponent } = options;
        if (!offerManager || !bus) {
            return;
        }

        postActionHandler(offerManager, bus, actionType, actionId, optionalThenFunc, optionalData, namedComponent);
    }

    function registerComponentLevelActionResponseHandler(componentName, handlerFunc) {
        componentResponseHandlers[componentName] = handlerFunc;
    }

    function cleanUp() {
        offerManager = null;
        bus = null;
        componentResponseHandlers = null;
        disposed = true;
    }

    return {
        handler: handler,
        cleanUp: cleanUp,
        registerComponentLevelActionResponseHandler: registerComponentLevelActionResponseHandler
    }


    function postActionHandler(offerManager, bus, actionType, actionId, optionalThenFunc, optionalData, namedComponent) {
        var textCode, dialogText;
        nextTick(function () {
            if(disposed) {
                return;
            }
            switch (actionType) {
                case config.ACTION_TYPE.EQUIPMENT_ADDED:
                    break;
                case config.ACTION_TYPE.ATTRIBUTE_VALUE_CHANGED:
                    if (actionId === config.ACTION_ID.CHASSIS_BODY_ALIGNMENT_BROKEN) {
                        textCode = '1630';
                        dialogText = config.getMessageText(textCode, globals.getActiveCultureCodeForTranslations());
                        globals.showDialog(new CustomMessageBox(dialogText, config.applicationTitle, [config.getTranslationText('271')], config.getMessageReference(textCode)));
                    } else if (actionId === config.ACTION_ID.CHASSIS_BODY_ALIGNMENT_BROKEN_DUE_TO_VALIDATION_FAILURE) {
                        textCode = '1631';
                        dialogText = config.getMessageText(textCode, globals.getActiveCultureCodeForTranslations());
                        globals.showDialog(new CustomMessageBox(dialogText, config.applicationTitle, [config.getTranslationText('271')], config.getMessageReference(textCode)));
                    } else if (actionId === config.ACTION_ID.IMPORT_WIZARD_ASPECT_RATIO_BROKEN_LENGTH) {
                        textCode = '4615';
                        dialogText = config.getMessageText(textCode, globals.getActiveCultureCodeForTranslations()).replace('$S1', optionalData.ReplaceString1).replace('$S2', optionalData.ReplaceString2).replace('$S1', optionalData.ReplaceString1).replace('$S2', optionalData.ReplaceString2); // User Story 17565
                        globals.showDialog(new CustomMessageBox(dialogText, config.applicationTitle, [config.getTranslationText('271')], config.getMessageReference(textCode)).setModalDisplayMode(config.MODAL_DISPLAY_MODE.OVERLAY))
                            .addCallback(function (dialogResult) {
                                if (dialogResult === config.getTranslationText('271')) {
                                    if (optionalThenFunc) {
                                        optionalThenFunc();
                                    }
                                }
                            });
                    }else if (actionId === config.ACTION_ID.IMPORT_WIZARD_ASPECT_RATIO_BROKEN_HEIGHT) {
                        textCode = '4614';
                        dialogText = config.getMessageText(textCode, globals.getActiveCultureCodeForTranslations()).replace('$S1', optionalData.ReplaceString1).replace('$S2', optionalData.ReplaceString2).replace('$S1', optionalData.ReplaceString1).replace('$S2', optionalData.ReplaceString2); // User Story 17565
                        globals.showDialog(new CustomMessageBox(dialogText, config.applicationTitle, [config.getTranslationText('271')], config.getMessageReference(textCode)).setModalDisplayMode(config.MODAL_DISPLAY_MODE.OVERLAY))
                            .addCallback(function (dialogResult) {
                                if (dialogResult === config.getTranslationText('271')) {
                                    if (optionalThenFunc) {
                                        optionalThenFunc();
                                    }
                                }
                            });
                    }
                    break;
                case config.ACTION_TYPE.SWAP:
                    if (actionId === config.ACTION_ID.SWAP_COMPLETED) {
                        textCode = '1632';
                        dialogText = config.getMessageText(textCode, globals.getActiveCultureCodeForTranslations()).replace('$S1', offerManager.getVehicleTitleComputed().value).replace('$S2', offerManager.getActiveOffer().getRig().getVehicle().getDescription()); // User Story 17565
                        globals.showDialog(new CustomMessageBox(dialogText, config.applicationTitle, [config.getTranslationText('576'), config.getTranslationText('261')], config.getMessageReference(textCode)))
                            .addCallback(function (dialogResult) {
                                if (optionalThenFunc) {
                                    optionalThenFunc(dialogResult);
                                }
                            });
                    } else if (actionId === config.ACTION_ID.REMOVE_ADDED_FIFTHWHEEL_AFTER_SWAP) {
                        if(namedComponent && componentResponseHandlers[namedComponent]) {
                            componentResponseHandlers[namedComponent](actionType, actionId, optionalThenFunc, optionalData);
                        } else {
                            offerManager.deleteObject(config.CHASSIS_OBJECT_TYPES.VEHICLE + '.' + config.OBJECT_TYPES.ACCESSORY + '.' + config.ACCESSORY_TYPES.FIFTH_WHEEL);
                        }
                    }
                    break;
                case config.ACTION_TYPE.VEHICLE_DATA:
                    if (actionId === config.ACTION_ID.VEHICLE_SUBMITTED) {
                        offerManager.closeOffer();
                        bus.emit('routeToSelection');
                    }
                    break;
                case config.ACTION_TYPE.CUSTOM_SAVE:
                    if (actionId === config.ACTION_ID.SAVE_WILL_OVERWRITE_CUSTOM_ACCESSORY) {
                        textCode = '1644';
                        dialogText = config.getMessageText(textCode, globals.getActiveCultureCodeForTranslations());
                        dialogText = dialogText.replace('$FirstName', optionalData.LastChangedUserFirstName).replace('$LastName', optionalData.LastChangedUserLastName); // User Story 17565
                        globals.showDialog(new CustomMessageBox(dialogText, config.applicationTitle, [config.getTranslationText('576'), config.getTranslationText('65')], config.getMessageReference(textCode)).setModalDisplayMode(config.MODAL_DISPLAY_MODE.OVERLAY))
                            .addCallback(function (dialogResult) {
                                if (dialogResult === config.getTranslationText('576')) {
                                    if (optionalThenFunc) {
                                        optionalThenFunc();
                                    }
                                }
                            });
                    } else if (actionId === config.ACTION_ID.NAME_ALREADY_EXISTS_TEAM) {
                        textCode = '1650';
                        dialogText = config.getMessageText(textCode, globals.getActiveCultureCodeForTranslations());
                        globals.showDialog(new CustomMessageBox(dialogText, config.applicationTitle, [config.getTranslationText('271')], config.getMessageReference(textCode)).setModalDisplayMode(config.MODAL_DISPLAY_MODE.OVERLAY))
                            .addCallback(function (dialogResult) {
                                if (optionalThenFunc) {
                                    optionalThenFunc();
                                }
                            });
                    } else if (actionId === config.ACTION_ID.NAME_ALREADY_EXISTS_PERSONAL) {
                        textCode = '1652';
                        dialogText = config.getMessageText(textCode, globals.getActiveCultureCodeForTranslations());
                        globals.showDialog(new CustomMessageBox(dialogText, config.applicationTitle, [config.getTranslationText('271')], config.getMessageReference(textCode)).setModalDisplayMode(config.MODAL_DISPLAY_MODE.OVERLAY))
                            .addCallback(function (dialogResult) {
                                if (optionalThenFunc) {
                                    optionalThenFunc();
                                }
                            });
                    } else if (actionId === config.ACTION_ID.ACCESS_LEVEL_CHANGED) {
                        textCode = '1649';
                        dialogText = config.getMessageText(textCode, globals.getActiveCultureCodeForTranslations());
                        globals.showDialog(new CustomMessageBox(dialogText, config.applicationTitle, [config.getTranslationText('271')], config.getMessageReference(textCode)).setModalDisplayMode(config.MODAL_DISPLAY_MODE.OVERLAY))
                            .addCallback(function (dialogResult) {
                                if (optionalThenFunc) {
                                    optionalThenFunc();
                                }
                            });
                    }
                    break;
                case config.ACTION_TYPE.CUSTOM_DELETE:
                    if (actionId === config.ACTION_ID.ALREADY_DELETED) {
                        textCode = '1649';
                        dialogText = config.getMessageText(textCode, globals.getActiveCultureCodeForTranslations());
                        globals.showDialog(new CustomMessageBox(dialogText, config.applicationTitle, [config.getTranslationText('271')], config.getMessageReference(textCode)))
                            .addCallback(function (dialogResult) {
                                if (optionalThenFunc) {
                                    optionalThenFunc();
                                }
                            });
                    } else if (actionId === config.ACTION_ID.ACCESS_LEVEL_CHANGED) {
                        textCode = '1649';
                        dialogText = config.getMessageText(textCode, globals.getActiveCultureCodeForTranslations());
                        globals.showDialog(new CustomMessageBox(dialogText, config.applicationTitle, [config.getTranslationText('271')], config.getMessageReference(textCode)))
                            .addCallback(function (dialogResult) {
                                if (optionalThenFunc) {
                                    optionalThenFunc();
                                }
                            });
                    }
                    break;
                case config.ACTION_TYPE.SAVE_OFFER:
                    if (actionId === config.ACTION_ID.SAVE_WILL_OVERWRITE_SHARED) {
                        textCode = '3058';
                        dialogText = config.getMessageText(textCode, globals.getActiveCultureCodeForTranslations());
                        dialogText = dialogText.replace('$FirstName', optionalData.LastModifiedByInfo.LastModifiedByUserFirstName).replace('$LastName', optionalData.LastModifiedByInfo.LastModifiedByUserLastName); // User Story 17565
                        globals.hideSpinner();
                        globals.showDialog(new CustomMessageBox(dialogText, config.applicationTitle, [config.getTranslationText('576'), config.getTranslationText('65')], config.getMessageReference(textCode)))
                            .addCallback(function (dialogResult) {
                                if (dialogResult === config.getTranslationText('576')) {
                                    if (optionalThenFunc) {
                                        optionalThenFunc();
                                    }
                                }
                            });
                    } else if (actionId === config.ACTION_ID.SHARE_ACCESS_PERMISSION_VIEW_ONLY) {
                        textCode = '3074';
                        dialogText = config.getMessageText(textCode, globals.getActiveCultureCodeForTranslations());
                        globals.showDialog(new CustomMessageBox(dialogText, config.applicationTitle, [config.getTranslationText('3075')], config.getMessageReference(textCode)))
                            .addCallback(function (dialogResult) {
                                offerManager.getActiveOffer().setSharePermission(globals.user.getEmailAddress(), config.SHARE_ACCESS_LEVEL_OPTIONS.VIEW_ONLY);
                                bus.emit('evaulateShowSaveOption');
                            });
                    }  else if (actionId === config.ACTION_ID.TEAM_CALCULATION_DELETED_BY_ANOTHER_USER) {
                        textCode = '5395';
                        dialogText = config.getMessageText(textCode, globals.getActiveCultureCodeForTranslations()).replace('$S1', optionalData.DeletedByInfo.DeletedByUserEmail);
                        globals.showDialog(new CustomMessageBox(dialogText, config.applicationTitle, [config.getTranslationText('271')], config.getMessageReference(textCode)))
                            .addCallback(function (dialogResult) {
                                if (optionalThenFunc) {
                                    optionalThenFunc();
                                }
                            });
                    } else if (actionId === config.ACTION_ID.SHARED_CALCULATION_DELETED_BY_ANOTHER_USER) {
                        textCode = '5396';
                        dialogText = config.getMessageText(textCode, globals.getActiveCultureCodeForTranslations()).replace('$S1', optionalData.DeletedByInfo.DeletedByUserEmail);
                        globals.showDialog(new CustomMessageBox(dialogText, config.applicationTitle, [config.getTranslationText('271')], config.getMessageReference(textCode)))
                            .addCallback(function (dialogResult) {
                                if (optionalThenFunc) {
                                    optionalThenFunc();
                                }
                            });
                    } else if (actionId === config.ACTION_ID.SAVE_WILL_OVERWRITE_TEAM) {
                        textCode = '5397';
                        dialogText = config.getMessageText(textCode, globals.getActiveCultureCodeForTranslations());
                        dialogText = dialogText.replace('$FirstName', optionalData.LastModifiedByInfo.LastModifiedByUserFirstName).replace('$LastName', optionalData.LastModifiedByInfo.LastModifiedByUserLastName); 
                        globals.hideSpinner();
                        globals.showDialog(new CustomMessageBox(dialogText, config.applicationTitle, [config.getTranslationText('576'), config.getTranslationText('65')], config.getMessageReference(textCode)))
                            .addCallback(function (dialogResult) {
                                if (dialogResult === config.getTranslationText('576')) {
                                    if (optionalThenFunc) {
                                        optionalThenFunc();
                                    }
                                }
                            });
                    }
                    
                    break;
            }
        });
        
    }
}

export { createOfferActionResponseHandler };
